import { BehaviorSubject } from 'rxjs';
import { API_CONSTANTS } from '../constants/api-constants';
import { IKeys } from 'app/interfaces';
const config = Object.assign({}, (window as { [key: string]: any })['environment']);
export const configurationSubject = new BehaviorSubject(config);
export function resolveEnvironment() {
  const env = configurationSubject.getValue();
  return env;
}

export function resolveOAuthConfig() {
  const oauth = configurationSubject.getValue().oauth;
  return oauth;
}

function getEnviroment(environment: string) {
  let env = null;
  switch (environment) {
    case 'test':
      env = 'tst';
      break;
    case 'dev':
      env = 'dev';
      break;
    case 'staging':
      env = 'stg';
      break;
    case 'prod':
      env = null;
      break;
  }
  return env;
}

export function resolveApiConfig() {
  let apiConfig = localStorage.getItem('environment');
  let apiKey = '';
  let subscriptionKey = '';
  let basicApi = '';
  let assessmentInstancesApi = '';
  let cpAssessmentNewApi = '';
  let production = false;
  let environment: string | null = '';
  if (apiConfig) {
    let apiConfigObj: IKeys = JSON.parse(apiConfig);
    if (apiConfigObj) {
      apiKey = apiConfigObj['apiKey'];
      subscriptionKey = apiConfigObj['subscriptionKey'];
      basicApi = apiConfigObj['basicApi'];
      assessmentInstancesApi = apiConfigObj['assessmentInstancesApi'];
      cpAssessmentNewApi = apiConfigObj['cpAssessmentNewApi'];
      production = apiConfigObj['production'];
      environment = getEnviroment(apiConfigObj['environment']);
    }
  }
  return {
    ...API_CONSTANTS,
    apiKey: apiKey,
    subscriptionKey: subscriptionKey,
    basicApi: basicApi,
    assessmentInstancesApi: assessmentInstancesApi,
    cpAssessmentNewApi: cpAssessmentNewApi,
    production: production,
    environment: environment,
  };
}
